/**
 * The decisions of a modal's focus and of "who plays with the keyboard", apart from the DOM so
 * they can be tested (review 0027 G1, G2). The hooks that apply them are in `useModalFocus.ts`.
 */

/**
 * Tab inside a modal: the index to focus next among its `count` focusable elements, `current`
 * being the focused one (-1 when the focus is outside, on the cards under the veil for one).
 * Focus goes round and never leaves (WAI-ARIA dialog pattern). Null when there is nothing to focus.
 */
export function nextFocus(count: number, current: number, backwards: boolean): number | null {
  if (count === 0) return null;
  if (current < 0) return backwards ? count - 1 : 0;
  return (current + (backwards ? count - 1 : 1)) % count;
}

const KEYBOARD_KEYS = new Set([
  "Tab",
  "Enter",
  " ",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
]);

/** A key that moves or presses: whoever uses these is playing with the keyboard. */
export function isKeyboardInput(key: string): boolean {
  return KEYBOARD_KEYS.has(key);
}
